// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CollectionCondenseList_wrapper__UrWvX"};